"use client";

import useDynamicSVGImport from "@utils/useDynamicSvgImport";

function IconSvg({ name = "circle-info" }) {
  const importedSvg = useDynamicSVGImport(name);
  if (importedSvg.loading) return null;

  const { SvgComponent } = importedSvg;

  return <SvgComponent className="w-100 icon-btn" />;
}

export default IconSvg;
